export default __webpack_public_path__ + "static/media/BD.7874ae8f.svg";